var React = require( 'react' );
var createReactClass = require('create-react-class');
var MatrixRow = require('./matrixRow.jsx');

var Matrix = createReactClass({

  render: function() {

    var columnHeaders = this.props.choices.map(function(choice, key) {
      return (
        <div key={this.props.name + '-choice-' + key} className="option-column">
            <h5>{choice.label}</h5>
        </div>
      );
    }.bind(this));

    const { rows = [], priorResponse } = this.props;
    const rowData = (Object.keys(rows).length > 0) ? rows : priorResponse;

    var rowLayout = rowData.map(function(res, key) {

      if (res) {
          var userResponse = [];
          // Need to first check for 0 since 'parseInt' does not return integer for 0
          // Was causing double selection bug when 0 value was selected and passed through
          const rowValue = (res.rowValue == 0) ? 0 : (parseInt(res.rowValue, 10) || res.rowValue);
          const value = (res.value == 0) ? 0 : (parseInt(res.value, 10) || res.value);
          const rowOrValue = (rowValue == 0) ? 0 : (rowValue || value);

          for(var i = 0; i < this.props.currentResponse.length; i++){
              //if(rowOrValue === this.props.currentResponse[i].rowValue){
                  userResponse.push(this.props.currentResponse[i]);
                  //break;
              //}
          }

        return (
          <MatrixRow
            name={res.tag}
            label={res.label || res.text}
            rowValue={rowOrValue}
            choices={this.props.choices}
            allowMulti={this.props.allowMulti}
            key={key}
            userResponse={userResponse}
            handleResponse={this.props.response} />
        );        
      }
    }.bind(this));

    return (
      <div className="matrix">
          <div className="head">
              <div className="title">
                  <h4>&nbsp;</h4>
              </div>
              {columnHeaders}
          </div>
            {rowLayout}
          <div className="foot"></div>
      </div>
    );
  }
});

module.exports = Matrix;



// WEBPACK FOOTER //
// ./src/common/routes/survey/components/field-types/matrix/matrix.jsx